import React from 'react';
import Common_Mst from './Common_Master';
import '../../CommonCSS/SocietyCSS.css'

const Company_MasterApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Common Masters </h5>
          </div>
        </div>
        <Common_Mst />
      </div>
    </div >
  );
};

export default Company_MasterApp;
